/**
 * Returns a date key for grouping (YYYY-MM-DD format)
 */
export function getDateKey(date: Date): string {
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/**
 * Returns a formatted date header string with "Today" and "Yesterday" handling
 */
export function getDateHeader(date: Date): string {
  const timeAgo = getEstimatedTimeAgo(date);
  if (timeAgo === "today") {
    return "Today";
  }
  if (timeAgo === "yesterday") {
    return "Yesterday";
  }
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export const getEstimatedTimeAgo = (date: Date) => {
  const now = new Date();
  const inputDate = new Date(date);

  // Reset time to start of day for both dates to compare calendar days
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const compareDate = new Date(
    inputDate.getFullYear(),
    inputDate.getMonth(),
    inputDate.getDate(),
  );

  const differenceInMs = today.getTime() - compareDate.getTime();
  const differenceInDays = Math.floor(differenceInMs / (1000 * 60 * 60 * 24));

  // if today return today
  if (differenceInDays === 0) {
    return "today";
  }
  // if yesterday return yesterday
  // if within last month return how many days ago
  if (differenceInDays < 31) {
    if (differenceInDays === 1) {
      return "yesterday";
    }
    return `${differenceInDays} days ago`;
  }
  // if within last year return how many months ago
  if (differenceInDays < 365) {
    const differenceInMonths = Math.floor(differenceInDays / 30);
    if (differenceInMonths > 0) {
      return `${differenceInMonths} month${differenceInMonths === 1 ? "" : "s"} ago`;
    }
    // fallback to days if less than a month
    return `${differenceInDays} days ago`;
  }
  // else return how many years ago
  const differenceInYears = now.getFullYear() - inputDate.getFullYear();
  return `${differenceInYears} year${differenceInYears === 1 ? "" : "s"} ago`;
};
